<p-dialog [(visible)]="display" [style]="{width: '50vw'}" (onHide)="closeModal()" [modal]="true">
    <ng-template pTemplate="header">
        <div class="link-label">
            <b>Get Document Link</b>
        </div>
    </ng-template>
<hr>

<div *ngIf="effectiveDocumentVersionLink" class="grid field">
    <div  class="col2">
        <bpt-text-input label="Effective Version Link (eQMS page)" title="This link leads to the Effective Version of the Document if it exists. If there is no Effective Version, an error is returned." [disabled]="true" id="effectiveVersionLink" [(ngModel)]="effectiveDocumentVersionLink"></bpt-text-input>
    </div>
    <div  class="col3">
        <app-copy-to-clipboard [textToCopy]="effectiveDocumentVersionLink"></app-copy-to-clipboard>
    </div>
    <div class="col3">
        <app-email [emailUrl]="effectiveDocumentVersionLink" [version]="documentDetail.version" [type]="effectiveVersionLink"
        [documentNumber]="documentDetail.number"></app-email>
    </div>
</div>
<div *ngIf="effectiveDocumentVersionSmartLink" class="grid field">
  <div  class="col2">
        <bpt-text-input label="Effective Version Link (Document File)" title="This link leads to the Effective Version of the Document if it exists. If there is no Effective Version, an error is returned." [disabled]="true" id="effectiveVersionSmartLink" [(ngModel)]="effectiveDocumentVersionSmartLink"></bpt-text-input>
    </div>
    <div  class="col3">
        <app-copy-to-clipboard [textToCopy]="effectiveDocumentVersionSmartLink"></app-copy-to-clipboard>
    </div>
    <div class="col3" style="visibility: hidden" aria-hidden="true">
        <app-email [emailUrl]="effectiveDocumentVersionSmartLink" [version]="documentDetail.version" [type]="effectiveVersionLink"
        [documentNumber]="documentDetail.number"></app-email>
    </div>
</div>
<div class="grid field">
    <div  class="col2">
        <bpt-text-input label="Specific Version Link (eQMS page)" title="This link leads to the Version of the Document it was generated from (i.e. this Version), regardless of the Phase of this Version or other Versions." [disabled]=true id="specificVersionLink" [(ngModel)]="specificDocumentVersionLink" ></bpt-text-input>
    </div>
    <div  class="col3">
        <app-copy-to-clipboard [textToCopy]="specificDocumentVersionLink"></app-copy-to-clipboard>
    </div>
    <div class="col3">
        <app-email [emailUrl]="specificDocumentVersionLink" [version]="documentDetail.version" [type]="specificVersionLink"
        [documentNumber]="documentDetail.number"></app-email>
    </div>
</div>
<div class="grid field">
    <div  class="col2">
        <bpt-text-input label="Latest Version Link (eQMS page)" title="This link leads to the Latest Version of the Document, regardless of the Phase of this Version or other Versions." [disabled]="true" id="latestVersionLink" [(ngModel)]="latestDocumentVersionLink"></bpt-text-input>
    </div>
    <div  class="col3">
        <app-copy-to-clipboard [textToCopy]="latestDocumentVersionLink"></app-copy-to-clipboard>
    </div>
    <div class="col3">
        <app-email [emailUrl]="latestDocumentVersionLink" [version]="documentDetail.version" [type]="latestVersionLink"
        [documentNumber]="documentDetail.number"></app-email>
    </div>
</div>
</p-dialog>
